import { createContext, useContext, useState, useMemo } from "react"
import {
	TableData,
} from "../components/tables/transactions-table/data/types"

interface ModalContextType {
	selectedItem: TableData | null
	setSelectedItem: (item: TableData | null) => void
	isModalOpen: boolean
	setModalOpen: (open: boolean) => void
	isClosing: boolean
	setIsClosing: (closing: boolean) => void
}

const ModalContext = createContext<ModalContextType | undefined>(undefined)

export function ModalProvider({ children }: { children: React.ReactNode }) {
	const [selectedItem, setSelectedItem] = useState<
		TableData | null
	>(null)
	const [isModalOpen, setModalOpen] = useState(false)
	const [isClosing, setIsClosing] = useState(false)

	const value = useMemo(
		() => ({
			selectedItem,
			setSelectedItem,
			isModalOpen,
			setModalOpen,
			isClosing,
			setIsClosing,
		}),
		[selectedItem, isModalOpen, isClosing]
	)

	return <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
}

export function useModal() {
	const context = useContext(ModalContext)
	if (context === undefined) {
		throw new Error("useModal must be used within a ModalProvider")
	}
	return context
}
